// @ts-strict-ignore
/** @jsx jsx */
import { jsx } from 'theme-ui'

import { connect } from 'react-redux'
import { includes } from '../redux/contentful-selectors'
import { Container } from './helpers/react'
import { contentId } from '../utils/contentful'
import ImgixImage from './helpers/imgix-image'

const QuoteBlock = (props) => {
  const author = props?.author?.fields
  const image = props?.authorImage?.fields?.file
  const quote = props?.content?.content[0].content[0].value
  return (
    <div
      sx={{
        bg: '#FCF1ED',
        py: ['lg', 'xxl', null],
      }}
    >
      <Container sx={{ maxWidth: 1100 }}>
        <div
          sx={{
            display: 'flex',
            flexDirection: ['column', 'row', null],
            alignItems: ['center', 'flex-start', null],
          }}
        >
          <If condition={author && image}>
            <ImgixImage
              sx={{
                display: 'block',
                maxWidth: 264,
                borderRadius: '50%',
              }}
              width={250}
              alt={author.name}
              src={image.url}
            />
          </If>
          <img
            sx={{
              position: 'relative',
              left: [0, 24, null],
              mt: ['lg', 0, null],
              mb: ['xl', 0, null],
            }}
            src='https://images.ctfassets.net/t014ej9w3ur1/5iEs4NM37OxwRW53JJTS3n/98b5c7734f00112a488534dda19e5683/___.svg'
            alt='quotation mark'
          />
          <div
            sx={{
              ml: [0, 50, null],
            }}
          >
            <blockquote
              sx={{
                m: 0,
                variant: 'styles.h2',
                textAlign: ['center', 'left', null],
                mt: 0,
                maxWidth: 570,
                lineHeight: 1.3,
              }}
            >
              {quote}&rdquo;
            </blockquote>
            <If condition={author}>
              <a
                href={author.url}
                sx={{
                  color: '#000000',
                  textDecoration: 'none',
                  textAlign: ['center', 'left', null],
                  display: 'inline-block',
                  width: ['100%', 'auto', null],
                }}
              >
                <span sx={{ fontWeight: 'bold' }}>{author.name}</span>, {author.role}
              </a>
            </If>
          </div>
        </div>
      </Container>
    </div>
  )
}

export default connect((state, { author = {} }) => {
  const connectedAuthor = includes(state)[contentId(author)]
  const authorImage = includes(state)[contentId(connectedAuthor?.fields?.image)]
  return {
    author: connectedAuthor,
    authorImage,
  }
})(QuoteBlock)
